import { render, staticRenderFns } from "./AssessmentList.vue?vue&type=template&id=4ead317c"
import script from "./AssessmentList.vue?vue&type=script&lang=js"
export * from "./AssessmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports